import React, { useState, useEffect } from 'react';
import { Card, Alert, Typography, Space, Tag, Button, Divider } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined, ReloadOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const ElectronDebug = () => {
  const [debugInfo, setDebugInfo] = useState({});
  const [loading, setLoading] = useState(false);

  const checkElectronDetection = () => {
    setLoading(true);
    
    const info = {
      // Méthodes de détection d'Electron
      windowRequire: !!(window.require && window.require('electron')),
      windowElectronAPI: !!(window.electronAPI),
      windowElectronAPIisElectron: !!(window.electronAPI && window.electronAPI.isElectron),
      userAgent: navigator.userAgent,
      platform: navigator.platform,
      
      // Informations sur l'API Electron
      electronAPIDetails: window.electronAPI ? {
        isElectron: window.electronAPI.isElectron,
        platform: window.electronAPI.platform,
        availableMethods: Object.keys(window.electronAPI)
      } : null,
      
      // Test des méthodes
      canCallWaterlinkAPI: !!(window.electronAPI && typeof window.electronAPI.waterlinkApi === 'function'),
      canCallCheckService: !!(window.electronAPI && typeof window.electronAPI.checkService === 'function'),
      
      // Informations sur l'environnement
      location: window.location.href,
      protocol: window.location.protocol,
      hostname: window.location.hostname,
      port: window.location.port
    };
    
    setDebugInfo(info);
    setLoading(false);
  };

  useEffect(() => {
    checkElectronDetection();
  }, []);

  const getStatusIcon = (condition) => {
    return condition ? 
      <CheckCircleOutlined style={{ color: '#52c41a' }} /> : 
      <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
  };

  const getStatusTag = (condition) => {
    return condition ? 
      <Tag color="success">Disponible</Tag> : 
      <Tag color="error">Non disponible</Tag>;
  };

  return (
    <div style={{ padding: '24px' }}>
      <Title level={2}>Débogage de la détection Electron</Title>
      
      <Card>
        <Space direction="vertical" style={{ width: '100%' }} size="large">
          <div>
            <Button 
              type="primary" 
              icon={<ReloadOutlined />} 
              onClick={checkElectronDetection}
              loading={loading}
            >
              Actualiser les informations
            </Button>
          </div>

          <Divider orientation="left">Méthodes de détection d'Electron</Divider>
          
          <Space direction="vertical" size="middle" style={{ width: '100%' }}>
            <div>
              <Space>
                {getStatusIcon(debugInfo.windowRequire)}
                <Text strong>window.require('electron'): </Text>
                {getStatusTag(debugInfo.windowRequire)}
              </Space>
            </div>

            <div>
              <Space>
                {getStatusIcon(debugInfo.windowElectronAPI)}
                <Text strong>window.electronAPI: </Text>
                {getStatusTag(debugInfo.windowElectronAPI)}
              </Space>
            </div>

            <div>
              <Space>
                {getStatusIcon(debugInfo.windowElectronAPIisElectron)}
                <Text strong>window.electronAPI.isElectron: </Text>
                {getStatusTag(debugInfo.windowElectronAPIisElectron)}
              </Space>
            </div>
          </Space>

          <Divider orientation="left">Informations sur l'API Electron</Divider>
          
          {debugInfo.electronAPIDetails ? (
            <Space direction="vertical" size="small" style={{ width: '100%' }}>
              <div>
                <Text strong>isElectron: </Text>
                <Tag color={debugInfo.electronAPIDetails.isElectron ? 'success' : 'error'}>
                  {debugInfo.electronAPIDetails.isElectron ? 'true' : 'false'}
                </Tag>
              </div>
              <div>
                <Text strong>Platform: </Text>
                <Text>{debugInfo.electronAPIDetails.platform}</Text>
              </div>
              <div>
                <Text strong>Méthodes disponibles: </Text>
                <Text code>{debugInfo.electronAPIDetails.availableMethods.join(', ')}</Text>
              </div>
            </Space>
          ) : (
            <Alert
              message="API Electron non disponible"
              description="window.electronAPI n'est pas défini"
              type="error"
              showIcon
            />
          )}

          <Divider orientation="left">Test des méthodes WaterLink</Divider>
          
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div>
              <Space>
                {getStatusIcon(debugInfo.canCallWaterlinkAPI)}
                <Text strong>waterlinkApi: </Text>
                {getStatusTag(debugInfo.canCallWaterlinkAPI)}
              </Space>
            </div>

            <div>
              <Space>
                {getStatusIcon(debugInfo.canCallCheckService)}
                <Text strong>checkService: </Text>
                {getStatusTag(debugInfo.canCallCheckService)}
              </Space>
            </div>
          </Space>

          <Divider orientation="left">Informations sur l'environnement</Divider>
          
          <Space direction="vertical" size="small" style={{ width: '100%' }}>
            <div>
              <Text strong>URL: </Text>
              <Text code>{debugInfo.location}</Text>
            </div>
            <div>
              <Text strong>Protocole: </Text>
              <Text code>{debugInfo.protocol}</Text>
            </div>
            <div>
              <Text strong>Hostname: </Text>
              <Text code>{debugInfo.hostname}</Text>
            </div>
            <div>
              <Text strong>Port: </Text>
              <Text code>{debugInfo.port}</Text>
            </div>
            <div>
              <Text strong>User Agent: </Text>
              <Text code style={{ fontSize: '12px' }}>{debugInfo.userAgent}</Text>
            </div>
            <div>
              <Text strong>Platform: </Text>
              <Text code>{debugInfo.platform}</Text>
            </div>
          </Space>

          <Divider orientation="left">Résumé</Divider>
          
          {debugInfo.windowElectronAPIisElectron ? (
            <Alert
              message="Mode Electron détecté"
              description="L'application s'exécute correctement dans Electron et l'API est disponible."
              type="success"
              showIcon
            />
          ) : (
            <Alert
              message="Mode Navigateur détecté"
              description="L'application s'exécute dans un navigateur web. Les fonctionnalités WaterLink ne seront pas disponibles."
              type="warning"
              showIcon
            />
          )}
        </Space>
      </Card>
    </div>
  );
};

export default ElectronDebug;


